var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "section p-4" }, [
    _c(
      "nav",
      {
        staticClass: "navbar is-primary-invert p-2",
        attrs: { role: "navigation", "aria-label": "main navigation" },
      },
      [
        _c("div", { staticClass: "navbar-brand" }, [
          _c(
            "a",
            {
              staticClass: "navbar-burger",
              class: { "is-active": _vm.isActive },
              attrs: {
                role: "button",
                "aria-label": "menu",
                "aria-expanded": "false",
              },
              on: {
                click: function ($event) {
                  _vm.isActive = !_vm.isActive
                },
              },
            },
            [
              _c("span", { attrs: { "aria-hidden": "true" } }),
              _vm._v(" "),
              _c("span", { attrs: { "aria-hidden": "true" } }),
              _vm._v(" "),
              _c("span", { attrs: { "aria-hidden": "true" } }),
            ]
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "navbar-menu navmenu",
            class: { "is-active": _vm.isActive },
          },
          [
            _c("div", { staticClass: "navbar-start" }, [
              _c("div", { staticClass: "tabs-with-buttons" }, [
                _c(
                  "div",
                  { staticClass: "buttons has-addons" },
                  [
                    _vm.$store.getters.hasAnyRole(["empleador"])
                      ? _c(
                          "b-button",
                          {
                            attrs: {
                              type:
                                _vm.activeTab === "subir_rec"
                                  ? "is-primary"
                                  : "is-light",
                            },
                            on: {
                              click: function ($event) {
                                _vm.activeTab = "subir_rec"
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "fas fa-upload fa-fw" }),
                            _vm._v(" Subir Recibos\n            "),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$store.getters.hasAnyRole(["lyris", "empleado"])
                      ? _c(
                          "b-button",
                          {
                            attrs: {
                              type:
                                _vm.activeTab === "rec_pend"
                                  ? "is-primary"
                                  : "is-light",
                              "icon-left": "file-signature",
                            },
                            on: { click: _vm.mostrarPendientesRec },
                          },
                          [
                            _vm._v(
                              "\n              Firmar mis pendientes\n            "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$store.getters.hasAnyRole(["lyris", "empleador"])
                      ? _c(
                          "b-button",
                          {
                            attrs: {
                              type:
                                _vm.activeTab === "org_pend"
                                  ? "is-primary"
                                  : "is-light",
                              "icon-left": "industry",
                            },
                            on: { click: _vm.mostrarPendientesOrg },
                          },
                          [
                            _vm._v(
                              "\n              Pendientes de la organización\n            "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$store.getters.hasAnyRole([
                      "lyris",
                      "empleado",
                      "empleador",
                    ])
                      ? _c(
                          "b-button",
                          {
                            attrs: {
                              type:
                                _vm.activeTab === "hist"
                                  ? "is-primary"
                                  : "is-light",
                              "icon-left": "history",
                            },
                            on: {
                              click: function ($event) {
                                _vm.activeTab = "hist"
                              },
                            },
                          },
                          [_vm._v("\n              Históricos\n            ")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "navbar-end" }, [
              _c(
                "div",
                { staticClass: "tabs-with-buttons" },
                [
                  _vm.activeTab != "subir_rec" && _vm.activeTab != "hist"
                    ? _c(
                        "b-button",
                        {
                          attrs: { "icon-left": "sync", type: "is-primary" },
                          on: { click: _vm.refresh },
                        },
                        [_vm._v("Recargar")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selectedRecibos.length
                    ? _c(
                        "b-button",
                        {
                          attrs: {
                            "icon-left": "download",
                            type: "is-success",
                          },
                          on: { click: _vm.download },
                        },
                        [
                          _vm._v(
                            " Descargar " +
                              _vm._s(_vm.selectedRecibos.length) +
                              " seleccionado" +
                              _vm._s(
                                _vm.selectedRecibos.length > 1 ? "s" : ""
                              ) +
                              "\n          "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _vm.activeTab === "subir_rec"
      ? _c("div", { staticClass: "panel-inferior" }, [
          _c(
            "div",
            { staticClass: "column is-6" },
            [
              _c("Empleador", {
                on: { "launch-firmador": _vm.launchFirmador },
              }),
            ],
            1
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.activeTab === "rec_pend"
      ? _c(
          "div",
          { staticClass: "panel-inferior" },
          [
            _c("ListadoPendientes", {
              ref: "listado_pend",
              attrs: { modo: "firmar" },
              on: { "firmar-pendientes": _vm.firmarPendientes },
            }),
          ],
          1
        )
      : _vm.activeTab === "org_pend"
      ? _c(
          "div",
          { staticClass: "panel-inferior" },
          [
            _c("ListadoPendientes", {
              ref: "listado_pend_org",
              attrs: { modo: "ver" },
            }),
          ],
          1
        )
      : _vm.activeTab === "hist"
      ? _c("div", { staticClass: "panel-inferior" }, [
          _c(
            "div",
            { staticClass: "columns" },
            [
              _c(
                "div",
                { staticClass: "column is-3 is-3-tablet is-3-desktop" },
                [_c("Filtros", { on: { "set-query": _vm.setQuery } })],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "column" }, [
                _c(
                  "div",
                  { staticClass: "box" },
                  [_c("Listado", { ref: "listado_hist" })],
                  1
                ),
              ]),
              _vm._v(" "),
              _vm.selectedRecibos.length
                ? _c("MultipleSidebar", { on: { download: _vm.download } })
                : _vm._e(),
            ],
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }